import React from "react";
import { motion } from "framer-motion";
import { GALLERY_IMAGES } from "../data/content";

export default function Campus() {
  return (
    <section
      id="campus"
      className="relative py-14 md:py-28 bg-[#FAFAF5]"
      data-testid="campus-section"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-12 gap-6 md:gap-10 items-end mb-8 md:mb-14">
          <div className="lg:col-span-6">
            <span className="text-xs font-bold tracking-[0.22em] uppercase text-[#648DE5] mb-5 block">
              Campus & Gallery
            </span>
            <h2 className="font-display text-[#0F1B47] text-[32px] md:text-5xl lg:text-6xl leading-[1.05] tracking-tight font-semibold">
              A place children are
              <br />
              <span className="italic font-normal">delighted</span> to belong to.
            </h2>
          </div>
          <div className="lg:col-span-5 lg:col-start-8">
            <p className="text-[#4A5568] text-base leading-relaxed font-light">
              Purpose-built studios, soft-light reading corners, an art atelier, an open
              kitchen and a garden where every season is a lesson. Designed with
              architects, teachers and three-year-olds alike.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 auto-rows-[140px] sm:auto-rows-[180px] md:auto-rows-[240px] gap-3 md:gap-4">
          {GALLERY_IMAGES.map((img, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, scale: 0.96 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.6, delay: i * 0.06 }}
              className={`relative overflow-hidden rounded-3xl group ${img.span}`}
              data-testid={`gallery-image-${i}`}
            >
              <img decoding="async" loading="lazy"
                src={img.url}
                alt={img.caption}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
